// Formatage des nombres pour l'affichage.

export function fmtNum(val: any): string {
  if (val == null || val === "") return "";
  const n = typeof val === "number" ? val : parseFloat(String(val));
  if (isNaN(n)) return String(val);
  return Math.abs(n).toLocaleString("fr-FR", { maximumFractionDigits: 2 });
}
